import {post_request} from '../axiosFun'

//查询列表
export const get_patrol_list = (params) => {
    params = {
        row:{
            car_number:params.car_number,
            task_number:params.task_number,
            task_name:params.task_name,
            size:params.page,
            limit:params.limit
        }
    }
    return post_request("/web/task_manage/inspection_manage/get_list",params)
}
//查询车辆列表
export const get_patrol_car_list = (params) => {
    params = {
        row:{
            car_id:params.car_id,
            car_not_id:params.car_not_id,
            size:params.page,
            limit:params.limit
        }
    }
    return post_request("/web/task_manage/inspection_manage/get_car",params)
}
//运维人员下拉列表
export const get_patrol_op_list = (params) => {
    params = {
        row:{
            size:params.page,
            limit:params.limit
        }
    }
    return post_request("/web/task_manage/inspection_manage/get_op_list",params)
}
//添加巡检配置
export const get_patrol_add = (params) => {
    params = {
        row:{
            task_name:params.task_name,
            task_number:params.task_number,
            patrol_cycle:params.patrol_cycle,
            operationer:params.operationer,
            car_group:params.car_group,
            remarks:params.remarks || "",
        }
    }
    return post_request("/web/task_manage/inspection_manage/add",params)
}
//获取单条
export const get_patrol_one_k_v = (params) => {
    params = {
        row:{
            id:params
        }
    }
    return post_request("/web/task_manage/inspection_manage/get_one_k_v",params)
}
export const get_patrol_one = (params) => {
    params = {
        row:{
            id:params
        }
    }
    return post_request("/web/task_manage/inspection_manage/get_one",params)
}
//编辑车辆组
export const get_car_id_update = (params) => {
    params = {
        row:{
            id:window.localStorage.getItem("patrol_id"),
            car_id:params.car_id,
            car_not_id:params.car_not_id,
            size:params.page,
            limit:params.limit
        }
    }
    return post_request("/web/task_manage/inspection_manage/get_car_id_update",params)
}
//编辑巡检配置
export const get_patrol_edit = (params) => {
    params = {
        row:{
            id:params.id,
            task_name:params.task_name,
            task_number:params.task_number,
            patrol_cycle:params.patrol_cycle,
            operationer:params.operationer,
            car_group:params.car_group,
            remarks:params.remarks || "",
        }
    }
    return post_request("/web/task_manage/inspection_manage/edit",params)
}
//删除
export const get_patrol_del = (params) => {
    params = {
        row:{
            id:params
        }
    }
    return post_request("/web/task_manage/inspection_manage/del",params)
}


// WEBPACK FOOTER //
// ./src/api/tast/patrol.js